export default __webpack_public_path__ + "static/media/deck_customize_hd.d0d1bbe4.webp";